export enum CommunitiesActionType {
  SET_COMMUNITIES = 'SET_COMMUNITIES',
  SEARCH_COMMUNITIES = 'SEARCH_COMMUNITIES',
  SET_COMMUNITIES_PAGINATION = 'SET_COMMUNITIES_PAGINATION',
  SET_COMMUNITIES_AFTER_SCROLL = 'SET_COMMUNITIES_AFTER_SCROLL',
  SET_CERTAIN_COMMUNITY = 'SET_CERTAIN_COMMUNITY',
  SET_COMMUNITIES_LOADING_STATUS = 'SET_COMMUNITIES_LOADING_STATUS',
}
